// キャンバスアイテム

// import { OffScreen } from "./OffScreen";
import Vue from 'vue'
import { EditConfig } from '@/js/Const.js'
import { CreateQRImage, CreateTextImage } from '@/js/CommonFunc.js'


function generateUuid() {
  let chars = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".split("");
  for (let i = 0, len = chars.length; i < len; i++) {
    switch (chars[i]) {
      case "x":
        chars[i] = Math.floor(Math.random() * 16).toString(16);
        break;
      case "y":
        chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16);
        break;
    }
  }
  return chars.join("");
}
class CanvasItemData {
  constructor() {
    // 背景画像データ
    // 配置アイテムリスト
    this.reset();
    this.rR = 0
    this.rG = 0
    this.rB = 0
    this.itemId = generateUuid()
  }
  setColorRGB(r, g, b) {
    this.rR = r
    this.rG = g
    this.rB = b

  }

  // このクラスが作成された場合必ずこの関数が呼ばれる
  init(file, canvasData, imageobj, name, type, option = {}, textNum = 0) {
    if(this.isTagImage){
      this.canvasData = null
    } else {
      this.canvasData = canvasData
    }

    // 各設定を保存
    this.file = file;
    this.imageobj = imageobj;
    this.itemType = type;
    this.itemName = name;
    this.fontSize = 100;

    // オプションの設定
    switch(type){
      case "Image":
        this.updateImage = function(){}
        break;
      case "Text":
        this.font = option.font;
        this.align = option.align;
        this.color = option.color;
        this.fontSize = option.fontSize;
        this.textArray = Array.from({ length: textNum }, () => "");
        Vue.set(this.textArray);  // リアクティブ化
        this.updateImage = this.updateTextImage;
        this.textArray = option.textList;
        this.scale = 1;
        break;
      case "QR":
        this.align = "center";
        this.color = option.color;
        this.bgColor = option.bgColor;
        // this.textArray = Array(textNum);
        // this.textArray.fill("");
        this.textArray = Array.from({ length: textNum }, () => "");
        Vue.set(this.textArray);  // リアクティブ化
        this.updateImage = this.updateQRImage;
        this.textArray = option.textList;
        this.scale = 1;
      break;
    }

    this.reset()

    switch(type){
      case "Image":
        break;
      case "Text":
        this.scale = 1;
        break;
      case "QR":
        this.scale = 2;
      break;
    }
  }

  async copy(canvasData){
    let data = new CanvasItemData()
    data.canvasData = canvasData
    data.file = this.file
    var src = window.URL.createObjectURL(data.file);
    let img = new Image()
    img.crossOrigin = 'Anonymous'
    img.src = src
    await this.imgload(img)
    data.imageobj = img
    data.itemName = this.itemName;
    data.itemType = this.itemType;
    data.fontSize = this.fontSize;
    data.font = this.font;
    data.align = this.align;
    data.color = this.color;
    data.bgColor = (this.bgColor)?this.bgColor:"";
    data.textArray = this.textArray;


    data.reset()

    data.posX = this.posX
    data.posY = this.posY
    data.imageWidth = this.imageWidth
    data.imageHeight = this.imageHeight
    data.rotate = this.rotate
    data.scale = this.scale
    data.rR = this.rR
    data.rG = this.rG
    data.rB = this.rB

    return data
  }
  imgload(img) {
    return new Promise((resolve) => {
        img.onload = () => {
            resolve()
        }
    })
  }

  setScale() {

  }
  getImagePath() {
    return this.image
    /*
    // カラーバランスを適用
    let imgH = this.imageobj.height,
        imgW = this.imageobj.width;
    
    let offs = new OffScreen(imgW, imgH)
    offs.drawImage(this.imageobj, 0, 0, imgW, imgH)
    let mg = offs.context.getImageData(0, 0, imgW, imgH);
    for (var i = 0; i < imgW * imgH * 4; i += 4) {
        var myRed = mg.data[i];
        var myGreen = mg.data[i + 1];
        var myBlue = mg.data[i + 2];
        mg.data[i] = myRed + this.rR > 255 ? 255 : myRed + this.rR;
        mg.data[i + 1] = myGreen + this.rG > 255 ? 255 : myGreen + this.rG;
        mg.data[i + 2] = myBlue + this.rB > 255 ? 255 : myBlue * this.rB;
    }
    offs.context.putImageData(mg,0,0)
    return offs.canvasImage();
    */
  }
  updatePosition(itemData) {
    this.posX = itemData.posX
    this.posY = itemData.posY
    this.imageWidth = itemData.imageWidth
    this.imageHeight = itemData.imageHeight
    this.rotate = itemData.rotate
    this.scale = itemData.scale
    this.rR = itemData.rR
    this.rG = itemData.rG
    this.rB = itemData.rB
  }
  normalizePosition() {
    // サイズがはみ出る場合も調整する
    if( this.scale < EditConfig.MinScale ){
      this.scale = EditConfig.MinScale;
    }
    if( this.scale > EditConfig.MaxScale ){
      this.scale = EditConfig.MaxScale;
    }

    return;
    // if (
    //   this.imageWidth >
    //   this.canvasData.canvasScreenSize.width
    // ) {

    //   let sa =
    //     this.imageWidth -
    //     this.canvasData.canvasScreenSize.width;
    //   let org = this.imageWidth;
    //   this.imageWidth = this.canvasData.canvasScreenSize.width;
    //   this.imageHeight =
    //     (this.imageWidth / org) * this.imageHeight;
    //   this.posX -= sa;
    //   this.posY -= (sa / org) * this.imageHeight;
    //   if (
    //     this.imageHeight >
    //     this.canvasData.canvasScreenSize.height
    //   ) {
    //     let sa =
    //       this.imageHeight -
    //       this.canvasData.canvasScreenSize.height;
    //     let org = this.imageHeight;
    //     this.imageHeight = this.canvasData.canvasScreenSize.height;
    //     this.imageWidth =
    //       (this.imageHeight / org) * this.imageWidth;
    //     this.posY -= sa;
    //     this.posX -= (sa / org) * this.imageWidth;
    //   }
    // }
    // if (
    //   this.imageHeight >
    //   this.canvasData.canvasScreenSize.height
    // ) {
    //   let sa =
    //     this.imageHeight -
    //     this.canvasData.canvasScreenSize.height;
    //   let org = this.imageHeight;
    //   this.imageHeight = this.canvasData.canvasScreenSize.height;
    //   this.imageWidth =
    //     (this.imageHeight / org) * this.imageWidth;
    //   this.posY -= sa;
    //   this.posX -= (sa / org) * this.imageWidth;
    //   if (
    //     this.imageWidth >
    //     this.canvasData.canvasScreenSize.width
    //   ) {
    //     let sa =
    //       this.imageWidth -
    //       this.canvasData.canvasScreenSize.width;
    //     let org = this.imageWidth;
    //     this.imageWidth = this.canvasData.canvasScreenSize.width;
    //     this.imageHeight =
    //       (this.imageWidth / org) * this.imageHeight;
    //     this.posX -= sa;
    //     this.posY -= (sa / org) * this.imageHeight;
    //   }
    // }
    // if (adjustSize) {
    //   if (this.imageHeight < 10) {
    //     let h = this.imageHeight / this.imageWidth
    //     this.imageHeight = 10
    //     this.imageWidth = 10 / h
    //   } else
    //     if (this.imageWidth < 10) {
    //       let h = this.imageWidth / this.imageHeight
    //       this.imageWidth = 10
    //       this.imageHeight = 10 / h
    //     }
    // }


    // if (
    //   this.posX <
    //   this.canvasData.canvasScreenPosition.x - 10
    // ) {
    //   console.log("1")

    //   this.posX =
    //     this.canvasData.canvasScreenPosition.x - 10;
    // }
    // if (
    //   this.posY <
    //   this.canvasData.canvasScreenPosition.y - 10
    // ) {
    //   console.log("2")
    //   this.posY =
    //     this.canvasData.canvasScreenPosition.y - 10;
    // }
    // if (
    //   this.imageHeight * this.scale + this.posY >
    //   this.canvasData.canvasScreenPosition.y +
    //   this.canvasData.canvasScreenSize.height -
    //   10
    // ) {
    //   console.log("3")
    //   this.posY =
    //     this.canvasData.canvasScreenPosition.y +
    //     this.canvasData.canvasScreenSize.height -
    //     this.imageHeight * this.scale -
    //     10;
    // }
    // if (
    //   this.imageWidth * this.scale + this.posX >
    //   this.canvasData.canvasScreenPosition.x +
    //   this.canvasData.canvasScreenSize.width -
    //   10
    // ) {
    //   console.log("4")
    //   this.posX =
    //     this.canvasData.canvasScreenPosition.x +
    //     this.canvasData.canvasScreenSize.width -
    //     this.imageWidth * this.scale -
    //     10;
    // }
  }

  reset() {
    if (this.canvasData) {
      this.name = "aaaaa";
      if (this.file.type.startsWith("image/")) {
        this.image = window.URL.createObjectURL(this.file);
        this.name = this.file.name;
        this.type = this.file.type;
      }
      this.imageWidth = this.imageobj.width / this.canvasData.canvasSize.width * this.canvasData.canvasScreenSize.width;
      this.imageHeight = this.imageWidth / this.imageobj.width * this.imageobj.height;

      // 画面に表示するサイズを調整
      this.posX = (this.canvasData.canvasScreenSize.width - this.imageWidth) / 2 + this.canvasData.canvasScreenPosition.x;
      this.posY = (this.canvasData.canvasScreenSize.height - this.imageHeight) / 2 + this.canvasData.canvasScreenPosition.y;
      this.rotate = 0;
      this.scale = 1;
      this.hrizontalVerticalCenter()

    } else {
      if (this.isTagImage &&  this.file.type.startsWith("image/")) {
        this.image = window.URL.createObjectURL(this.file);
        this.name = this.file.name;
        this.type = this.file.type;
        this.posX = 28 - 10;
        this.posY = 37 - 10;
        this.imageWidth = 194;
        this.imageHeight = 194 / this.imageobj.width * this.imageobj.height;
        this.rotate = 0;
        this.scale = 1;
  
      } else {
        this.posX = 0;
        this.posY = 0;
        this.imageWidth = 100;
        this.imageHeight = 100;
        this.rotate = 0;
        this.scale = 1;  
      }
    }
  }
  adjustArtboard() {
    // 枠の分は引く
    let newWidth = this.canvasData.canvasScreenSize.width
    let newHeight = newWidth / this.imageWidth * this.imageHeight
    if (newHeight > this.canvasData.canvasScreenSize.height) {
      newHeight = this.canvasData.canvasScreenSize.height
      newWidth = newHeight / this.imageHeight * this.imageWidth
    }
    this.imageWidth = newWidth
    this.imageHeight = newHeight
    this.hrizontalVerticalCenter()
  }
  topHrizontalCenter() {
    // 枠の分は引く
    this.posY = this.canvasData.canvasScreenPosition.y - 10
    this.horizontalCenter()
  }
  hrizontalVerticalCenter() {
    // 枠の分は引く
    this.posX = (this.canvasData.canvasScreenSize.width - (this.imageWidth + 20)) / 2 + this.canvasData.canvasScreenPosition.x;
    this.posY = (this.canvasData.canvasScreenSize.height - (this.imageHeight + 20)) / 2 + this.canvasData.canvasScreenPosition.y;
  }
  horizontalCenter() {
    this.posX = (this.canvasData.canvasScreenSize.width - (this.imageWidth + 20)) / 2 + this.canvasData.canvasScreenPosition.x;
  }
  getNowDpi() {
    // 最初の状態が300dpi
    let firstWidth = this.imageobj.width / this.canvasData.canvasSize.width * this.canvasData.canvasScreenSize.width;
    let dpi = (300 / (this.imageWidth / firstWidth)).toFixed(1) > 300 ? 300 : (300 / (this.imageWidth / firstWidth)).toFixed(1)
    return "" + dpi + "dpi"
  }
  getNowmm() {
    //1ピクセルはなんミリ
    let pi = this.canvasData.canvasMiriMeterSize.width / this.canvasData.canvasScreenSize.width
    return "" + (this.imageWidth * pi).toFixed() + " x " + ((this.imageHeight * pi).toFixed()) + "mm"
  }
  toJson() {
    return JSON.stringify({
      posX: this.posX,
      posY: this.posY,
      imageWidth: this.imageWidth,
      imageHeight: this.imageHeight,
      rotate: this.rotate,
      scale: this.scale,
      rR: this.rR,
      rG: this.rG,
      rB: this.rB,
      itemId: this.itemId,
      itemName: this.itemName,
      itemType: this.itemType,
      fontSize: parseInt(this.fontSize),
      font: this.font,
      align: this.align,
      color: this.color,
      bgColor: (this.bgColor)?this.bgColor:"",
      textArray: this.textArray,
    })
  }
  getProperty() {
    return {
      posX: this.posX,
      posY: this.posY,
      imageWidth: this.imageWidth,
      imageHeight: this.imageHeight,
      rotate: this.rotate,
      scale: this.scale,
      rR: this.rR,
      rG: this.rG,
      rB: this.rB,
      itemId: this.itemId,
      itemName: this.itemName,
      itemType: this.itemType,
      fontSize: this.fontSize,
      font: this.font,
      align: this.align,
      color: this.color,
      bgColor: (this.bgColor)?this.bgColor:"",
      textArray: this.textArray,
    }
  }


  // ===== 画像更新周り ===== //
  async updateTextImage(index){
    const imageData = await CreateTextImage(this.textArray[index], this.font, this.color, this.fontSize);
    this.file = imageData.blob;
    this.imageobj.src = URL.createObjectURL(imageData.blob);
    await this.imgload(this.imageobj);

    //const previousWidth = this.imageWidth;
    this.image = URL.createObjectURL(imageData.blob);
    this.imageWidth = this.imageobj.width / this.canvasData.canvasSize.width * this.canvasData.canvasScreenSize.width;
    this.imageHeight = this.imageWidth / this.imageobj.width * this.imageobj.height;

    // switch(this.align){
    //   case "left": break;
    //   case "center": this.posX -= (this.imageWidth - previousWidth)/2; break;
    //   case "right": this.posX -= this.imageWidth - previousWidth; break;
    // }
  }

  async updateQRImage(index){
    const imageData = await CreateQRImage(this.textArray[index], this.color, this.bgColor);
    this.file = imageData.blob;
    this.imageobj.src = URL.createObjectURL(imageData.blob);
    this.image = URL.createObjectURL(imageData.blob);
    const QRSize = 100;
    this.imageWidth = QRSize / this.canvasData.canvasSize.width * this.canvasData.canvasScreenSize.width;
    this.imageHeight = QRSize / this.canvasData.canvasSize.height * this.canvasData.canvasScreenSize.height;
    await this.imgload(this.imageobj);

    // const previousWidth = this.imageWidth;
    // this.image = URL.createObjectURL(blob);
    // this.imageWidth = this.imageobj.width / this.canvasData.canvasSize.width * this.canvasData.canvasScreenSize.width;
    // this.imageHeight = this.imageWidth / this.imageobj.width * this.imageobj.height;

    // switch(this.align){
    //   case "left": break;
    //   case "center": this.posX -= (this.imageWidth - previousWidth)/2; break;
    //   case "right": this.posX -= this.imageWidth - previousWidth; break;
    // }
  }

  // updateTextNum(newNum){
  //   this.textNum = newNum;
  //   this.textArray.length = newNum;
  //   console.log(this.textArray);
  // }

  updateQuantity(num){
    console.log("updateQuantity");
    this.textArray.splice(num);
    // for( var i=0; i<num; i++ ){
    //   if(!this.textArray[i]) Vue.set(this.textArray, i, {"text":""});
    // }

    // this.textArray.forEach(function (text) {
    //   if(!text) Vue.set(text, 0, {"text":text});
    //   // text = {"text":text};
    // })
  }




  // テキストデータから画像を生成する
  // async createImageForText(text, font, align, color){
  //   const canvas = document.createElement("canvas");
  //   const context = canvas.getContext("2d");
  //   const size = 100;

  //   context.textAlign = align;
  //   context.textBaseline = "middle";
  //   context.font = size + "px " + font;

  //   if( text == "" ) text = "";
  //   //console.log(text);

  //   const mesure = context.measureText(text);
  //   const textWidth =  mesure.width;
  //   const textHeight =  mesure.actualBoundingBoxAscent + mesure.actualBoundingBoxDescent + (size/2);
  //   canvas.width = textWidth;
  //   canvas.height = textHeight;

  //   context.textAlign = align;
  //   context.textBaseline = "middle";
  //   context.font = size + "px " + font;
  //   context.fillStyle = color;
  //   let x = 0;
  //   switch(align){
  //     case "left": x=0; break;
  //     case "center": x=textWidth/2; break;
  //     case "right": x=textWidth; break;
  //   }

  //   let y = textHeight/2;
  //   context.fillText(text, x, y);

  //   const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
  //   return blob;
  // }



}
export { CanvasItemData }